import React from 'react'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
// const isMobile = browserCheck.isMobile

export const influenza = [
  {
    typ: 'Russische Grippe',
    date: '1889–1895',
    casesCH: 'ca. 900’000',
    casesWorld: '300–900 Mio.',
    deathsCH: '2624',
    deathsWorld: 'ca. 1 Mio.',
    influenza: true,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Vor 130 Jahren brach mit der sogenannten Russischen Grippe die
              erste globale Pandemie aus. Laut Zeitgenossen wurde das Virus
              erstmals 1889 in Usbekistan entdeckt. Per Zug und Schiff breitete
              es sich über Russland nach Europa und schliesslich auch nach
              Übersee aus. Es forderte in mehreren Wellen etwa{' '}
              <Link href='https://link.springer.com/article/10.1007/s13337-020-00628-5#Sec2'>
                eine Million Todesopfer
              </Link>{' '}
              weltweit. In der Schweiz wütete die Pandemie im Jahr 1890, als
              gemäss dem damaligen Chef des Eidgenössischen Statistischen Büros,{' '}
              <Link href='https://digital.zbmed.de/gesundheitspflege/content/pageview/5848546'>
                Friedrich Schmid
              </Link>
              , 2624 Menschen an Influenza starben – ein Vielfaches mehr als in
              normalen Jahren.
            </p>
            <p>
              Ob es sich wirklich um eine Grippe handelte, ist aber umstritten.
              So fand eine belgische Forschergruppe um den Virologen Marc van
              Ranst von der Universität Leuven schon 2005{' '}
              <Link href='https://jvi.asm.org/content/79/3/1595'>Indizien</Link>{' '}
              dafür, dass die Krankheit nicht von einem Influenzavirus, sondern
              durch das Coronavirus HCoV-OC43 ausgelöst wurde. Zum selben
              Ergebnis kam 2020 eine noch nicht publizierte Studie dänischer
              Forscher um{' '}
              <Link href='https://forskning.ruc.dk/en/persons/lonesimo'>
                Lone Simonsen
              </Link>
              , Epidemiologin an der Universität Roskilde.
            </p>
            <p>
              Auch sonst erinnert vieles der Russischen Grippe an heute: Die
              Ärzte wussten lange gar nicht, womit sie es zu tun hatten, das
              Gesundheitswesen war überfordert. Fast täglich berichteten schon
              damals die Medien über neuste Entwicklungen der Pandemie in aller
              Welt. In Basel und Zürich, wo die ersten Fälle Anfang Dezember
              1889 festgestellt wurden, gab es Schulschliessungen,
              Veranstaltungen wurden abgesagt. So konnte wohl noch Schlimmeres
              verhindert werden.
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Spanische Grippe',
    date: '1918/19',
    casesCH: 'ca. 2 Mio.',
    casesWorld: 'ca. 500 Mio.',
    deathsCH: 'ca. 25’000',
    deathsWorld: '20–100 Mio.',
    influenza: true,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              An der Spanischen Grippe, die durch ein besonders virulentes
              Influenzavirus vom Subtyp A/H1N1 verursacht wurde, starben in der
              Schweiz 1918/19 fast{' '}
              <Link href='https://geschichte.redcross.ch/ereignisse/ereignis/der-kampf-gegen-die-spanische-grippe.html'>
                25’000
              </Link>{' '}
              Menschen bei damals 4 Millionen Einwohnern. Es war eine der
              schlimmsten Katastrophen in der Schweizer Geschichte. Weltweit
              raffte die Spanische Grippe je nach Schätzung{' '}
              <Link href='https://www.who.int/influenza/preparedness/pandemic/GIP_PandemicInfluenzaRiskManagementInterimGuidance_Jun2013.pdf?ua=1'>
                20
              </Link>{' '}
              bis{' '}
              <Link href='https://wwwnc.cdc.gov/eid/article/12/1/05-0979_article'>
                100
              </Link>{' '}
              Millionen Menschen dahin – deutlich mehr, als im Ersten Weltkrieg
              starben.
            </p>
            <p>
              Schätzungen zufolge steckten sich in der Schweiz rund zwei
              Millionen Menschen an, was der Hälfte der damaligen Bevölkerung
              entspricht. Die erste Ansteckungswelle von Mai bis August 1918
              verlief relativ glimpflich. Die zweite Welle, die von September
              1918 bis Mai 1919 dauerte und im November ihren Höhepunkt
              erreichte, forderte massiv mehr Todesopfer. Wie beim aktuellen
              Coronavirus traf die erste Welle damals hauptsächlich die
              Westschweizer Kantone, die zweite erfasste die ganze Schweiz.
            </p>
            <div className='column special'>
              <div className='titleBox'>
                <h4 className='graphicTitle'>
                  Die zweite Welle traf die Bevölkerung viel heftiger
                </h4>
                <div className='graphicSub'>
                  Monatliche Grippetote in der Schweiz, 1918–1919.
                </div>
              </div>
              <div className='graphicBox'>
                <div className='boxWrapper Two'>
                  <div className='iframeBox Two'>
                    <AutofitIFrame
                      src='https://datawrapper.dwcdn.net/inTwy/'
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
                <div className='source'>
                  <>
                    <span>
                      Hinweis: Gesamtbevölkerung der Schweiz
                      3'864'844&nbsp;Personen (1.&nbsp;Januar&nbsp;1919)
                    </span>
                    <br />
                    Quellen: Eidgenössisches Statistisches Büro, Statistisches
                    Jahrbuch 1919
                  </>
                </div>
              </div>
            </div>
            <p>
              Besonders auffällig: 70 Prozent der Todesopfer waren zwischen 20
              und 49 Jahre alt, auch solche in gutem körperlichem Zustand. Die
              Kranken bekamen neben üblichen Grippesymptomen Flecken im Gesicht,
              spuckten Blut, ihre Körper verfärbten sich violett, am Ende
              erstickten viele. Bei älteren Personen war praktisch kein Anstieg
              der Todesfälle festzustellen. Anders bei den 20- bis 39-Jährigen:
              1917 gab es 6000 Grippetote, ein Jahr später waren es rund 20’000.
              Somit starben 1918 mehr junge Erwachsene als ältere Personen.
            </p>
            <div className='column special'>
              <div className='titleBox'>
                <h4 className='graphicTitle'>
                  Starker Anstieg der Todesfälle bei den Jüngeren
                </h4>
                <div className='graphicSub'>
                  Grippetote nach Altersklasse in der Schweiz, 1917–1919
                </div>
              </div>
              <div className='graphicBox'>
                <div className='boxWrapper Two'>
                  <div className='iframeBox Two'>
                    <AutofitIFrame
                      src='https://datawrapper.dwcdn.net/FjBuM/'
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
                <div className='source'>Quelle: Bundesamt für Statistik</div>
              </div>
            </div>
            <p>
              Der Massnahmenkatalog im Kampf gegen das Virus war ähnlich wie
              heute: Schulen, Kinos, Kirchen und Märkte blieben geschlossen,
              Versammlungen und Spitalbesuche waren verboten. In Trams durfte
              man nur noch sitzen. Tanz-, Theater- und Konzertaufführungen
              wurden abgesagt. Alle öffentlichen Telefone wurden einmal täglich
              mit Formalin desinfiziert. Militärbaracken und Schulhäuser wurden
              zu Notfallspitälern umfunktioniert. Das Pflegepersonal schob
              Sonderschichten bis zur Erschöpfung. Offen blieben die Restaurants
              mit reduzierter Bestuhlung. Der Verkauf von Gesichtsmasken,
              Desinfektionsmitteln und Särgen boomte.
            </p>
            <p>
              Eine kürzlich{' '}
              <Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7901603/'>
                publizierte Studie
              </Link>{' '}
              eines Forschungsteams der Universitäten Zürich und Toronto zeigt,
              dass die Schweiz am Beispiel des Kantons Bern 1918 ähnlich hilflos
              agierte wie heute bei der Corona-Pandemie. Gleich wie im
              vergangenen Herbst der Bundesrat zögerten auch 1918 die Berner
              Kantonsbehörden mit Massnahmen gegen die zweite Welle. Das
              Argument war fast identisch: Man fürchtete die wirtschaftlichen
              Folgen. Der Kanton Bern überliess in der Folge die Verantwortung
              den einzelnen Gemeinden. Ein Déjà-vu: Es kam zu einem
              Flickenteppich mit lokal sehr unterschiedlich starken Eingriffen.{' '}
              <Link href='145190543589'>Für die Forscher</Link> war dies der
              Hauptgrund, wieso die zweite Welle anschliessend viel stärker
              ausfiel und 80 Prozent der Opfer der Spanischen Grippe forderte.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={require('../../images/spanische-grippe.jpeg')}
            className='cbImage influenzaImage'
            aspectRatio={browserCheck.isMobile ? '3:2' : '16:9'}
            source={
              <>
                <span>
                  Anfangs waren vor allem Soldaten betroffen: Militärisches
                  Krankenzimmer 1918.
                </span>
                <br />
                Foto: ETH-Bibliothek Zürich, Bildarchiv
              </>
            }
          />
        </div>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Medizin war damals weitgehend machtlos und probierte vieles
              aus: Aspirin mit Chinin, das schon gegen Malaria wirkte. Zum
              Einsatz kamen auch Arsen, Quecksilber und sogar Morphium und
              Heroin. In der Schweiz konzentrierten sich die Anstrengungen auf
              die Pflege der Kranken. Die Pandemie sorgte für einen fast
              kompletten Zusammenbruch des Gesundheitswesens.
            </p>
            <p>
              Der Ursprung der Pandemie ist bis heute ungeklärt. Eine Hypothese
              besagt, er sei in den USA erstmals aufgetaucht und von dort von
              amerikanischen Soldaten, die zur Verstärkung der Alliierten nach
              Europa kamen, eingeschleppt worden. Eine andere situiert den
              Ursprung im Fernen Osten, von wo die meisten Grippeepidemien
              stammen. Ihren Namen bekam die Spanische Grippe, weil Spanien
              keinen Hehl aus den vielen Krankheitsfällen machte und besonders
              schwer betroffen war.
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Asiatische Grippe',
    date: '1957/58',
    casesCH: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    casesWorld: 'ca. 580 Mio.',
    deathsCH: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    deathsWorld: 'ca. 1,1 Mio.',
    influenza: true,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Nach der Spanischen Grippe dauerte es fast vierzig Jahre, bis
              wieder ein neuartiges Influenzavirus auftrat, gegen das ein
              Grossteil der Bevölkerung nicht immun war: 1957 wurden in China
              die ersten Krankheitsfälle durch den Subtyp A/H2N2 registriert.
              Über den internationalen Schiffsverkehr verbreitete sich das Virus
              nach Europa und löste eine Pandemie aus. Bis 1958 infizierten sich{' '}
              <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/vergangene-epidemien-pandemien/grippepandemie.html#:~:text=Die%20n%C3%A4chste%20Influenza%2DPandemie%20trat,0%2C4%20%25).'>
                rund 20 Prozent
              </Link>{' '}
              der Weltbevölkerung mit der sogenannten Asiatischen Grippe, also
              etwa 580 Millionen und damit mehr als bei der Spanischen Grippe.
            </p>
            <p>
              Trotzdem starben nur etwa{' '}
              <Link href='https://www.cdc.gov/flu/pandemic-resources/1957-1958-pandemic.html'>
                1,1 Millionen
              </Link>{' '}
              Menschen weltweit. Der Virusstamm war viel weniger gefährlich als
              noch bei der Spanischen Grippe. Gleichzeitig war die
              Gesundheitsversorgung mittlerweile besser, die Medizin hatte
              grosse Fortschritte gemacht. Zudem wurde schnell eine Impfung
              gegen das H2N2-Virus entwickelt, die auch in der Schweiz zum
              Einsatz kam.
            </p>
            <p>
              Hierzulande gab es lediglich eine leichte Zunahme an Todesfällen,
              die Asiatische Grippe verlief also glimpflich. Genaue Zahlen zu
              Infektionen und Opfern findet man aber nicht. Die Pandemie hatte
              hierzulande schlicht zu wenig Auswirkungen, als dass man sie
              wirklich erfasst und aufgearbeitet hätte. Ein Team des Instituts
              für Evolutionsmedizin an der Universität Zürich will das bald
              ändern (siehe Box weiter unten).
            </p>
            <p>
              Noch bis 1968 verursachte das Virus der Asiatischen Grippe
              alljährlich weitere Infektionen. Danach wurde H2N2 durch einen
              neuen Subtyp abgelöst und verschwand. 2005 kam es in den USA
              allerdings zu einem Zwischenfall, als H2N2-Virusproben
              versehentlich an mehrere Labors verschickt wurden. Die
              Weltgesundheitsorganisation (
              <Link href='https://web.archive.org/web/20050413184313/http://www.who.int/csr/disease/influenza/h2n2_2005_04_12/en/'>
                WHO
              </Link>
              ) ordnete die sofortige Vernichtung der Proben an und konnte so
              neuerliche Infektionen verhindern.
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Hongkong-Grippe',
    date: '1968–1970',
    casesCH: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    casesWorld: 'ca. 500 Mio.',
    deathsCH: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    deathsWorld: 'ca. 1 Mio.',
    influenza: true,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die als Hongkong-Grippe bezeichnete dritte Influenza-Pandemie des
              20. Jahrhunderts brach im Sommer 1968 mutmasslich in Hongkong aus.
              Von da aus breitete sie sich zuerst in Asien und bis Ende Jahr auf
              der ganzen Welt aus, unter anderem durch US-Soldaten, die aus dem
              Vietnamkrieg heimkehrten. Beim Virus handelte es sich um eine
              Mutation des A/H2N2-Virus, das zehn Jahre zuvor die Asiatische
              Grippe verursacht hatte und jetzt durch den Subtyp A/H3N2
              verdrängt wurde.
            </p>
            <p>
              Wieder starb geschätzt{' '}
              <Link href='https://www.cdc.gov/flu/pandemic-resources/1968-pandemic.html'>
                1 Million
              </Link>{' '}
              Menschen weltweit. Zur Schweiz gibt es keine genauen Zahlen. In
              den Jahren 1968 bis 1970 wurden aber nur unwesentlich mehr
              Grippetote gezählt. Ein Grund könnte sein, dass die Immunabwehr
              mancher Menschen schon Antikörper gegen die ursprüngliche Version
              des Virus enthielt.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={require('../../images/hongkong-grippe.jpg')}
            className='cbImage influenzaImage'
            aspectRatio={browserCheck.isMobile ? '3:2' : '16:9'}
            source={
              <>
                <span>
                  Stehen Schlange für die Grippeimpfung: Mitarbeiter der Zeitung
                  «Blick» im Jahr 1968.
                </span>
                <br />
                Foto: Getty Images
              </>
            }
          />
        </div>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Eine entscheidende Rolle bei der Eindämmung der Pandemie spielte
              auch die Entwicklung eines{' '}
              <Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7150172/'>
                Impfstoffs gegen H3N2
              </Link>{' '}
              durch den US-Mikrobiologen Maurice Hilleman. Zudem waren wie schon
              bei der Asiatischen Grippe die medizinischen Möglichkeiten
              grösser, Erkrankte zu behandeln.
            </p>
            <p>
              Im Gegensatz zu H2N2 verschwand der Subtyp H3N2 aber nicht mehr
              und zirkuliert seither weltweit als einer der Stämme der
              saisonalen Grippe. H3N2-Viren, die bei älteren Menschen schwere
              Erkrankungen verursachen können, durchlaufen regelmässig
              sogenannte Antigendrifts. Das heisst, sie mutieren – genauso wie
              andere Influenza-A-Viren. Grippe-Impfstoffe müssen aus diesem
              Grund jährlich den neuen Antigentypen angepasst werden.
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Russische Grippe',
    date: '1977/78',
    casesCH: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    casesWorld: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    deathsCH: browserCheck.isMobile ? 'Daten fehlen' : 'Daten fehlen',
    deathsWorld: 'ca. 700’000',
    influenza: true,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Auch wenn sie denselben Namen trägt, hat diese Pandemie nichts mit
              der ersten Russischen Grippe neunzig Jahre vorher zu tun. Die
              Sowjetunion war einfach das erste Land, das der WHO einen Ausbruch
              meldete, deshalb die Bezeichnung. Erstmals isoliert wurde das
              Influenzavirus im Mai 1977 in Nordchina, bis Januar 1978 hatte es
              sich weltweit verbreitet.
            </p>
            <p>
              Es handelte sich um den Subtyp A/H1N1, der einst auch die
              Spanischen Grippe verursachte. Mit geschätzten{' '}
              <Link href='https://link.springer.com/article/10.1007%2Fs00430-009-0118-5'>
                700’000 Todesfällen
              </Link>{' '}
              weltweit verlief die Pandemie aber weitaus glimpflicher und wurde
              deshalb auch nicht wirklich erfasst. Genaue Zahlen zu Ansteckungen
              findet man nicht. In der Schweiz führte die Pandemie laut dem{' '}
              <Link
                href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/vergangene-epidemien-pandemien/grippepandemie.html'
                allowWordWrap
              >
                Bundesamt für Gesundheit (BAG)
              </Link>{' '}
              zu keiner merklichen Übersterblichkeit. Denn betroffen waren
              dieses Mal vor allem Kinder und Jugendliche, die weniger anfällig
              für schwere Verläufe sind.
            </p>
            <p>
              <Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3291411/'>
                Forscher
              </Link>{' '}
              vermuten, dass die nach 1957 Geborenen keinen Immunschutz gegen
              H1N1 hatten, weil der Subtyp damals von H2N2 verdrängt wurde (und
              dieser 1968 wieder durch H3N2). Während der zweiten Russischen
              Grippe entwickelten Wissenschaftler dann den ersten trivalenten
              Impfstoff, der sowohl Bestandteile der A-Stämme H1N1 und H3N2
              enthielt als auch einen Stamm vom Typ B.
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Sars',
    date: '2002-2004',
    casesCH: '0',
    casesWorld: '8000',
    deathsCH: '0',
    deathsWorld: '800',
    influenza: false,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Infektionskrankheit Sars (Severe Acute Respiratory Syndrome)
              wurde von Coronaviren verursacht und tauchte zwischen November
              2002 und Mai 2004 in zahlreichen Ländern vor allem in Südostasien
              auf. Weltweit steckten sich aber nur rund{' '}
              <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/vergangene-epidemien-pandemien/sars-2003-04-weltweit.html'>
                8000 Personen
              </Link>{' '}
              mit dem Virus Sars-CoV-1 an, das in fast 10 Prozent der Fälle
              tödlich war. Weil die Erkrankten durch das schwere Atemwegssyndrom
              hohes Fieber entwickelten, konnten sie schnell isoliert werden.
              Vermutlich war das Virus auch weniger ansteckend als Sars-CoV-2.
            </p>
            <p>
              Die Schweiz kam glimpflich davon: Zwar gab es im Frühjahr 2003
              rund 30 Verdachtsfälle, wie das{' '}
              <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/vergangene-epidemien-pandemien/sars-2003-04-weltweit.html'>
                BAG
              </Link>{' '}
              rückblickend schreibt. Doch bei keinem dieser Patienten konnte das
              Virus nachgewiesen werden. In der Schweiz gab es also keinen
              einzigen Sars-Fall. Seit Mitte 2004 auch weltweit nicht mehr.
            </p>
            <p>
              Trotzdem hatte die erste Pandemie des 21. Jahrhunderts grosse
              Auswirkungen: Internationale Gesundheitsvorschriften wurden
              überarbeitet. Die EU baute 2003 ein Zentrum für
              Krankheitsprävention auf, das heutige European Centre for Disease
              Control (ECDC). Und die Schweiz beschloss parallel dazu die
              Totalrevision ihres Epidemiengesetzes.
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Schweinegrippe',
    date: '2009/10',
    casesCH: '13’441',
    casesWorld: '491’382',
    deathsCH: '20',
    deathsWorld: '18’499',
    influenza: true,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              «Neue Grippe», «Amerikagrippe», «Mexikanische Grippe»: Die
              Pandemie in den Jahren 2009 und 2010 hatte viele Namen,
              durchgesetzt hat sich aber «Schweinegrippe», weil man zu Beginn
              annahm, dass sie von Schweinen auf Menschen übertragen wurde. Es
              handelte sich um eine neuartige, mutierte Form des A/H1N1-Virus,
              das auch schon die Spanische Grippe verursachte. Glücklicherweise
              steckten sich aber viel weniger Menschen an als damals.
            </p>
            <p>
              Insgesamt wurden der{' '}
              <Link href='https://www.who.int/csr/disease/swineflu/laboratory06_08_2010/en/'>
                WHO
              </Link>{' '}
              gut 491’000 laborbestätigte Fälle und 18’000 Todesfälle gemeldet.
              Verschiedene Forscher gehen allerdings von einer hohen
              Dunkelziffer und deshalb viel höheren Zahlen aus. Eine{' '}
              <Link href='https://www.thelancet.com/journals/laninf/article/PIIS1473-3099(12)70121-4/fulltext#%20'>
                Studie
              </Link>{' '}
              des amerikanischen Centers for Disease Control and Prevention
              (CDC) zum Beispiel schätzt, dass die Schweinegrippe 150’000 bis
              575’000 Opfer gefordert hat.
            </p>
            <p>
              In der Schweiz erkrankten im Vergleich zur normalen, saisonalen
              Grippe weniger Ältere, dafür häufig jüngere Menschen mit
              geringerem Risiko eines schweren Verlaufs. Deshalb gab es nur{' '}
              <Link href='11670279'>20 Todesfälle</Link> – viel weniger als
              befürchtet. Das BAG hatte vor der Pandemie gewarnt und für 80
              Prozent der Bevölkerung Impfstoffe gekauft. Weil sich aber nur 17
              Prozent impfen liessen, musste ein Grossteil der Dosen entsorgt
              werden. Kritik wurde laut, unnötig Angst geschürt und Steuergelder
              verschleudert zu haben. Die Schweinegrippe förderte ein Misstrauen
              gegenüber den Behörden.
            </p>
          </div>
          <div
            className='ui vertical fitted segment'
            style={{ paddingBottom: 0 }}
          >
            <div className='ui ta text biobox container'>
              <blockquote className='quote'>
                <p>
                  «Das lange Ausbleiben gefährlicher Pandemien hat zu einer
                  Katastrophen-Gedächtnislücke geführt.»
                </p>
                <img
                  className='ui medium circular image centered'
                  src={require('../../images/kaspar-staub.jpg')}
                />
                <div className='names'>Kaspar Staub</div>
                <div className='byline'>
                  Institut für Evolutionsmedizin der Universität Zürich
                </div>
              </blockquote>
              <p>
                Nach der Spanischen Grippe von 1918/19 wurde die Schweiz hundert
                Jahre lang nicht mehr von einer schweren Pandemie heimgesucht.
                Es gab zwar immer wieder Infektionskrankheiten, die sich
                weltweit rasch und stark ausbreiteten (Asiatische Grippe,
                Hongkong-Grippe, Russische Grippe, Sars, Schweinegrippe). Doch
                hierzulande führten sie zu keinem markanten Anstieg der
                Todesfälle und wurden deshalb nicht als unmittelbare Gefahr
                wahrgenommen. Kaspar Staub und seine Kollegen vom Institut für
                Evolutionsmedizin der Universität Zürich sprechen in diesem
                Zusammenhang von einem{' '}
                <span style={{ whiteSpace: 'nowrap' }}>
                  «
                  <Link href='https://smw.ch/op-eds/post/the-pandemic-gap'>
                    Pandemie-Gap
                  </Link>
                  »
                </span>
                .
              </p>
              <p>
                «Das Ausbleiben gefährlicher Pandemien über einen längeren
                Zeitraum hat das Risikobewusstsein der Bevölkerung beeinflusst»,
                sagt Staub. «Es hat zu einer Art pandemischen
                Katastrophen-Gedächtnislücke geführt.» Laut dem Forscher ist es
                ganz natürlich, dass Erfahrungen nach zwei oder drei
                Generationen aus dem kollektiven Gedächtnis verschwinden. Welche
                Auswirkungen eine Pandemie haben kann, hatte die Schweizer
                Bevölkerung vergessen – bis die aktuelle Corona-Krise ausbrach.
              </p>
              <p>
                Dieses fehlende Bewusstsein hatte sicher auch mit der sinkenden
                Sterblichkeitsrate aufgrund von Influenza in der zweiten Hälfte
                des 20. Jahrhundert zu tun. Durch den steigenden Lebensstandard,
                die bessere Gesundheitsversorgung und die Entwicklung von
                Impfstoffen verlor die saisonale Grippe ihren Schrecken.
                Gleichzeitig wurden globale Infektionskrankheiten wie die
                Asiatische Grippe, die Hongkong-Grippe und die Russische Grippe
                in der Schweiz gar nicht richtig erfasst, weil sie glimpflich
                verliefen. Staub und sein Team wollen diese historischen
                Pandemien nun genauer aufarbeiten und haben ein neues
                Forschungsprojekt gestartet.
              </p>
            </div>
          </div>
        </div>
      </>
    )
  },
  {
    typ: 'Covid-19',
    date: '2019–2021',
    casesCH: '648’478',
    casesWorld: '148’716’872',
    deathsCH: '10’593',
    deathsWorld: '3’134’956',
    influenza: false,
    content: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Ende 2019 tauchten in der chinesischen Stadt Wuhan die ersten
              Meldungen über eine mysteriöse Lungenerkrankung auf. Schnell
              stellte sich heraus, dass das dafür verantwortliche Coronavirus
              Sars-CoV-2 hoch ansteckend ist. Innert weniger Wochen verbreitete
              es sich von China aus auf der ganzen Welt aus. Nun, gut ein Jahr
              später, sind gemäss <Link href='18727947'>dieser Übersicht</Link>{' '}
              schon mehr als 3 Millionen Menschen im Zusammenhang mit Covid-19
              gestorben.
            </p>
            <p>
              In der Schweiz gab es bis zum 28. April 2021 über 648’000
              Infektionen und fast 10’600 Todesfälle. Während der ersten und
              zweiten Welle kam es zu einer{' '}
              <Link href='448160073753'>Übersterblichkeit</Link>, es starben
              also deutlich mehr Menschen als normalerweise in dieser Jahreszeit
              – trotz Lockdowns, Einschränkungen und Schutzmassnahmen. Nicht
              vergessen darf man auch, dass die Menschen, gerade die älteren,
              heute viel gesünder sind als früher. Zudem hat die Medizin grosse
              Fortschritte gemacht, bei Impfungen und Behandlungsmethoden.
            </p>
            <p>
              Dennoch hat Covid-19 schon jetzt mehr Opfer gefordert als alle
              bisherigen Pandemien in der Schweiz, mit Ausnahme der Spanischen
              Grippe. Oft haben Infektionskrankheiten nur kurz gewütet, die
              erste Russische Grippe zum Beispiel im Januar 1890. Die aktuelle
              Corona-Krise aber zieht sich schon seit Monaten hin – und es ist
              kein Ende in Sicht.
            </p>
          </div>
        </div>
      </>
    )
  }
]
